import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";

var SvgPointerChevronRight = function SvgPointerChevronRight(props) {
  return _jsx("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), {}, {
    children: _jsx("path", {
      fill: props.color || '#909090',
      d: "M18.863 12.838c-.181.555-.534 1.086-1.056 1.593l-9.543 9.01c-.395.365-.85.55-1.365.559-.514.008-.945-.155-1.293-.488A1.87 1.87 0 0 1 5 22.145a1.75 1.75 0 0 1 .558-1.343L14.888 12l-9.33-8.79A1.737 1.737 0 0 1 5 1.88c.008-.523.21-.975.606-1.355.332-.365.76-.539 1.281-.523a2.02 2.02 0 0 1 1.377.594l9.567 8.987c.506.507.85 1.037 1.032 1.592.183.555.183 1.11 0 1.664Z"
    })
  }));
};

export default SvgPointerChevronRight;